export const GET_LIKES = "GET_LIKES";
export const LIKE = "LIKE";
